import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList } from "@/mixins/index";
import addproduct from "./components/addproduct.vue";
import watchEnvir from "./components/watchEnvir.vue";
export default {
  name: "indexInterview",
  mixins: [loadMoreList],
  components: {
    addproduct: addproduct,
    watchEnvir: watchEnvir
  },
  data: function data() {
    return {
      pagingReqFn: "products",
      pagingReqValue: "data",
      paramsData: {
        name: '',
        status: ''
      }
    };
  },
  mounted: function mounted() {},
  activated: function activated() {
    this.getList();
  },
  methods: {
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'productsDelete',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};